import React from 'react'
import { IconProps } from 'types/common'

/** Rising bars — Dashboard nav. Discover keeps the four-square grid. */
const DashboardIcon: React.FC<Partial<IconProps>> = ({
  width = 24,
  height = 24,
  stroke = 'currentColor',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="3.5" y="14" width="4.5" height="6.5" rx="1.5" stroke={stroke} strokeWidth="1.75" />
      <rect x="9.75" y="9" width="4.5" height="11.5" rx="1.5" stroke={stroke} strokeWidth="1.75" />
      <rect x="16" y="4" width="4.5" height="16.5" rx="1.5" stroke={stroke} strokeWidth="1.75" />
    </svg>
  )
}

export default DashboardIcon
